import { Image, StyleSheet, View } from "react-native";
import { MultiAppConfig } from "@config/MultiAppConfig";

export const SplashScreenPage = () => {
  return (
    <View style={styles.view}>
      <Image source={MultiAppConfig.LOGO} resizeMode="center" />
    </View>
  );
};

const styles = StyleSheet.create({
  view: {
    flex: 1,
    backgroundColor: MultiAppConfig.PRIMARY_COLOR,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
});
